import Reflux from 'reflux';

export default Reflux.createActions({
  clearTransientCellValue: { sync: true },
  setTransientCellValue: { sync: true },
});
